import { gql } from 'apollo-angular'

import { AUTHOR_BASIC_FIELDS } from '../../fragments/author.fragments'

export const SEARCH_AUTHORS = gql`
  ${AUTHOR_BASIC_FIELDS}
  query SearchAuthors($firstName: String!, $lastName: String!) {
    Authors(
      where: {
        AND: [
          {
            OR: [
              { first_name: { contains: $firstName } }
              { last_name: { contains: $firstName } }
            ]
          }
          {
            OR: [
              { first_name: { contains: $lastName } }
              { last_name: { contains: $lastName } }
            ]
          }
        ]
      }
    ) {
      docs {
        ...AuthorBasicFields
      }
    }
  }
`
